import { InputBaseComponentProps } from '@mui/material';
import { ChangeEvent, KeyboardEvent, Ref } from 'react';

import { InputAdornmentStyled, OutlinedInputStyled } from './InputStyled';

export interface InputProps {
  autoFocus?: boolean;
  disabled?: boolean;
  endAdornment?: JSX.Element;
  error?: boolean;
  fullWidth?: boolean;
  id: string;
  inputRef?: Ref<HTMLTextAreaElement | HTMLInputElement>;
  inputProps?: InputBaseComponentProps;
  name?: string;
  onChange?: (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  onKeyDown?: (
    event: KeyboardEvent<HTMLInputElement | HTMLInputElement>
  ) => void;
  pattern?: RegExp;
  placeholder?: string;
  startAdornment?: JSX.Element;
  type?: string;
  value?: string;
}

export const Input = ({
  endAdornment,
  onChange,
  inputProps,
  pattern,
  startAdornment,
  ...props
}: InputProps) => {
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (onChange && (!pattern || pattern.test(event.target.value))) {
      onChange(event);
    }
  };

  return (
    <OutlinedInputStyled
      data-testid="input-wrapper"
      endAdornment={
        endAdornment && (
          <InputAdornmentStyled position="end" data-testid="end-adornment">
            {endAdornment}
          </InputAdornmentStyled>
        )
      }
      startAdornment={
        startAdornment && (
          <InputAdornmentStyled position="start" data-testid="start-adornment">
            {startAdornment}
          </InputAdornmentStyled>
        )
      }
      inputProps={{
        'data-testid': 'input',
        ...inputProps,
      }}
      onChange={handleChange}
      {...props}
    />
  );
};
